import CareLevelModuleStatistic from './CareLevelModuleStatistic';

export default CareLevelModuleStatistic;
